import { Link } from 'components/link/Link';
import { Logo } from 'components/logo/Logo';

import style from './HomeButton.module.scss';

export type HomeButtonType = {
  isHome: boolean;
};
export const HomeButton = ({isHome}: HomeButtonType): JSX.Element => {

  return (
    <Link href="/">
      <a className={style.logo}>
        <Logo isHome={isHome} />
      </a>
    </Link>
  );
};
